import {commonPromise} from '@/http'
// 普通接口

let getLocalStores_url = '/store/getlocalstores'; 
let getStoreDetail_url = '/store/shopdetail';
let getBuyCart_url = '/cart/querycart';
let addBuyCart_url = '/cart/inc';
let editBuyCart_url = '/cart/moditynum';
let deleteBuyCart_url = '/cart/delete';

export const getLocalStoresFetch = (data) => commonPromise(data, getLocalStores_url, 'post');
export const getStoreDetailFetch = (data) => commonPromise(data, getStoreDetail_url, 'post');
export const getBuyCartFetch = (data) => commonPromise(data, getBuyCart_url, 'post');
export const addBuyCartFetch = (data) => commonPromise(data, addBuyCart_url, 'post');
export const editBuyCartFetch = (data) => commonPromise(data, editBuyCart_url, 'post');
export const deleteBuyCartFetch = (data) => commonPromise(data, deleteBuyCart_url, 'post');


// WEBPACK FOOTER //
// ./src/api/storeApi.js